import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNote2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNote2"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V14.9142L14.9142 21H3V3ZM5 5V19H13V13H19V5H5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNote2;
